export class SaleOrderLineOther {
  constructor(
    public hash?: string,
    public concept?: string,
    public amount?: number
  ) { }

  clone() {
    return new SaleOrderLineOther(
      this.hash,
      this.concept,
      this.amount
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-line-other.ts